import { useEffect, useState } from "react"
import { InputModel } from "../../../../../../../../../utils/types"
import { priorities, providers } from "../../../constans/constants";
import { Priority } from "../../../../../../../../../utils/enums/priority";
import { Item } from "../../../../../../../../../utils/types/generals";

const useInput = ({ priority,items }: { priority:Priority | undefined, items?: Item[] }) =>{
    const [input, setInput] = useState<{ [x: string]: InputModel }>({
      nameSubCategory: {
        label: 'catalog.inputs.subCategory',
        translate: true,
        name: 'nameSubCategory',
        type: 'text',
        validate: {
          required: true,
        },
        customeErrors: {
          required: 'catalog.form.crud.subCategoryName',
        },
        rest: {
          type: 'alphaNumeric',
          inputProps: {
            maxLength: 200,
          },
        },
        value: null,
        size: {
          lg: 12,
          md: 12,
          sm: 12,
          xl: 12,
          xs: 12
        }
      },
      textField: {
        label: 'catalog.inputs.textField',
        translate: true,
        name: 'textField',
        type: 'check',
        items: priorities,
        value: null,
        size: {
          lg: 12,
          md: 12,
          sm: 12,
          xl: 12,
          xs: 12
        }
      },
      priority: {
        label: 'catalog.inputs.priority',
        translate: true,
        name: 'priority',
        validate: {
          required: true,
        },
        type: 'select-search',
        items: priorities,
        value: null,
        size: {
          lg: 6,
          md: 6,
          sm: 6,
          xl: 6,
          xs: 6
        }
      },
    })

  const providerField: InputModel = {
    label: "catalog.inputs.provider",
    translate: true,
    name: "provider",
    /* validate: {
      required: true,
    }, */
    type: "select-search",
    items: items,
    value: null,
    size: {
      lg: 6,
      md: 6,
      sm: 6,
      xl: 6,
      xs: 6,
    },
  };

  useEffect(() => {
    const priorityValue = priority;

    if (priorityValue === Priority.HIGH || priorityValue === Priority.URGENT) {
      setInput((prevInput) => ({
        ...prevInput,
        provider: providerField,
      }));
    } else {
      setInput((prevInput) => {
        const { provider, ...rest } = prevInput;
        return rest;
      });
    }
  }, [priority]);

  /* useEffect(() => {
    let body = {}
    Object.entries(input).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: items?.[key] } }
    })

    setInput(body)

  }, [items])  */


    return {input}
}


export { useInput }